import { styled } from "@linaria/react";
import { colors } from "../../../styles/utils/vars";
import { cssIcon } from "../Icon";
import { Paragraph14, Span } from "../Typography/Typography";
export const StyledIconText = /*#__PURE__*/styled(Paragraph14)({
  name: "StyledIconText",
  class: "StyledIconText_sbh5u2y"
});

require("./StyledIconText.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledIconText.tsx");